import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import React, { useContext, useState } from "react";
import { langAsset, langContext } from "../../api/Lang";
import Popup from "../../api/Popup";
import { languageFromValue } from "../../api/langConfig";
import { useOrderStrings } from "../order-strings";

export default function GefsinusNavPanel() {
    const [rawLang] = useContext(langContext);
    const lang = languageFromValue(rawLang);
    const orderStrings = useOrderStrings();
    const [dlgOpen, setDlgOpen] = useState(false);
    const logoSrc = langAsset('gefsinusLogoDark', lang);

    const closeDlg = (): void => setDlgOpen(false);
    const openDlg = (): void => setDlgOpen(true);

    return (
        <>
            <div
                className="gefsinus-nav-trigger"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                    e.stopPropagation();
                    openDlg();
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        openDlg();
                    }
                }}
                aria-label={orderStrings.cateringTagline}
            >
                <p className="gefsinus-nav-tagline">{orderStrings.cateringTagline}</p>
                <img
                    className="gefsinus-nav-logo"
                    src={logoSrc}
                    alt="Gefsinus"
                    width={155}
                    height={48}
                    decoding="async"
                />
            </div>
            {dlgOpen && (
                <Popup onClose={closeDlg}>
                    <div
                        className="gefsinus-nav-dlg"
                        role="dialog"
                        aria-labelledby="gefsinus-nav-dlg-title"
                    >
                        <IconButton
                            className="gefsinus-nav-dlg-close"
                            onClick={closeDlg}
                            size="small"
                            aria-label={orderStrings.gefsinusBannerCloseAria}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        <div className="gefsinus-nav-dlg-accent">
                            <img
                                className="gefsinus-nav-dlg-logo"
                                src={logoSrc}
                                alt="Gefsinus"
                                width={155}
                                height={48}
                                decoding="async"
                            />
                            <img
                                className="gefsinus-nav-dlg-veggies"
                                src="/img-assets/veggies.svg"
                                alt=""
                            />
                        </div>
                        <div className="gefsinus-nav-dlg-content">
                            <p id="gefsinus-nav-dlg-title" className="gefsinus-nav-dlg-lead">
                                {orderStrings.cateringTagline}
                            </p>
                            <ul className="gefsinus-nav-dlg-list">
                                <li>
                                    {orderStrings.cateringBullet1We}
                                    <strong>{orderStrings.cateringBullet1Bold}</strong>
                                    {orderStrings.cateringBullet1Rest}
                                </li>
                                <li>
                                    {orderStrings.cateringBullet2We}
                                    <strong>{orderStrings.cateringBullet2Bold}</strong>
                                    {orderStrings.cateringBullet2Rest}
                                </li>
                                <li>
                                    {orderStrings.cateringBullet3We}
                                    <strong>{orderStrings.cateringBullet3Bold}</strong>
                                    {orderStrings.cateringBullet3Rest}
                                </li>
                            </ul>
                        </div>
                    </div>
                </Popup>
            )}
        </>
    );
}
